import { useEffect, useDebugValue, useCallback } from 'react';
import { useMeasuredCookieState } from './useMeasuredCookieState';
function isServerRendering() {
    return typeof document === 'undefined' || typeof window === 'undefined';
}
export function useMeasuredCookie(cookieType, containerRef, _a) {
    var defaultSizeProp = _a.defaultSize, _b = _a.cookieDim, cookieDim = _b === void 0 ? 'both' : _b, listenOnWindow = _a.listenOnWindow, sentinelRef = _a.sentinelRef, _c = _a.version, version = _c === void 0 ? 0 : _c;
    var _d = useMeasuredCookieState(cookieType, cookieDim, defaultSizeProp, !!sentinelRef || isServerRendering()), containerSize = _d.containerSize, defaultSizeForPlatform = _d.defaultSizeForPlatform, updateContainerSize = _d.updateContainerSize;
    useDebugValue(containerSize, function (size) { return "Width: ".concat(size === null || size === void 0 ? void 0 : size.width, ", height: ").concat(size === null || size === void 0 ? void 0 : size.height); });
    var measureContainerSize = useCallback(function () {
        function getContainerSize() {
            // We are in browser from here
            var _a;
            var containerElement = containerRef.current;
            var rect = containerElement === null || containerElement === void 0 ? void 0 : containerElement.getBoundingClientRect();
            if (!rect || (!rect.width && !rect.height)) {
                return defaultSizeForPlatform;
            }
            var sentinelWidth = (_a = sentinelRef === null || sentinelRef === void 0 ? void 0 : sentinelRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width;
            return {
                // Make sure container is never bigger than parent
                // this allows us to shrink the container :)
                width: sentinelWidth && sentinelWidth < rect.width
                    ? sentinelWidth
                    : rect.width,
                height: rect.height,
            };
        }
        var newSize = getContainerSize();
        updateContainerSize(newSize);
    }, [containerRef, defaultSizeForPlatform, sentinelRef, updateContainerSize]);
    useEffect(function () {
        measureContainerSize();
        if (listenOnWindow) {
            window.addEventListener('resize', measureContainerSize);
            return function () { return window.removeEventListener('resize', measureContainerSize); };
        }
    }, [listenOnWindow, measureContainerSize, version]);
    return containerSize;
}
//# sourceMappingURL=useMeasuredCookie.js.map